import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Button, cn } from '@agenda-facil/ui';
import { Brand } from '../components/brand';
import { ThemeToggle } from '../components/theme-toggle';

const nav = [
  ['Sobre', '/sobre'],
  ['Recursos', '/recursos'],
  ['Planos', '/planos'],
] as const;

export function MarketingLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen overflow-x-hidden">
      <header className="sticky top-0 z-40 border-b border-[color-mix(in_srgb,var(--border)_80%,transparent)] bg-[color-mix(in_srgb,var(--background)_90%,transparent)] backdrop-blur-lg">
        <div className="page-shell flex h-[var(--header-height)] items-center justify-between gap-5">
          <Link to="/" aria-label="Agenda Fácil — início"><Brand /></Link>
          <nav className="hidden items-center gap-1 md:flex" aria-label="Navegação principal">
            {nav.map(([label, href]) => (
              <NavLink key={href} to={href} className={({ isActive }) => cn('rounded-full px-4 py-3 text-sm font-bold text-[var(--muted-foreground)] transition hover:text-[var(--foreground)]', isActive && 'bg-[var(--surface-raised)] text-[var(--foreground)]')}>
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-2 md:flex">
            <ThemeToggle />
            <Button variant="ghost" asChild><Link to="/login">Entrar</Link></Button>
            <Button asChild><Link to="/teste-gratis">Testar grátis</Link></Button>
          </div>
          <div className="flex items-center md:hidden">
            <ThemeToggle />
            <Button variant="ghost" size="icon" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label="Abrir menu">
              {open ? <X size={22} /> : <Menu size={22} />}
            </Button>
          </div>
        </div>
        {open && (
          <nav className="page-shell grid gap-1 border-t border-[var(--border)] py-4 md:hidden">
            {nav.map(([label, href]) => <Link key={href} to={href} className="rounded-xl px-4 py-3 font-bold" onClick={() => setOpen(false)}>{label}</Link>)}
            <Link to="/login" className="rounded-xl px-4 py-3 font-bold" onClick={() => setOpen(false)}>Entrar</Link>
            <Button className="mt-2" asChild><Link to="/teste-gratis" onClick={() => setOpen(false)}>Começar teste grátis</Link></Button>
          </nav>
        )}
      </header>
      <main><Outlet /></main>
      <footer className="border-t border-[var(--border)] bg-[var(--brand-strong)] py-14 text-[#f7f3e9]">
        <div className="page-shell grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
          <div className="max-w-sm"><Brand className="text-white" /><p className="mt-5 text-sm leading-7 text-white/65">Mais ritmo no atendimento, menos tempo preso em planilhas e mensagens.</p></div>
          <div><p className="text-xs font-extrabold uppercase tracking-[.14em] text-[var(--accent)]">Produto</p><div className="mt-4 grid gap-3 text-sm text-white/75"><Link to="/recursos">Recursos</Link><Link to="/planos">Planos</Link><Link to="/contato">Contato</Link></div></div>
          <div><p className="text-xs font-extrabold uppercase tracking-[.14em] text-[var(--accent)]">Confiança</p><div className="mt-4 grid gap-3 text-sm text-white/75"><Link to="/privacidade">Privacidade</Link><Link to="/termos">Termos de uso</Link><span>© {new Date().getFullYear()} Agenda Fácil</span></div></div>
        </div>
      </footer>
    </div>
  );
}
